import { render, staticRenderFns } from "./byrpage.vue?vue&type=template&id=9c718832&scoped=true&"
import script from "./byrpage.vue?vue&type=script&lang=js&"
export * from "./byrpage.vue?vue&type=script&lang=js&"
import style0 from "./byrpage.vue?vue&type=style&index=0&id=9c718832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c718832",
  null
  
)

export default component.exports